export default __webpack_public_path__ + "static/media/llamada_SPDP_mensaje.fa806327.mp3";